// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Toast from './plugins/toast'
import Clipboard from './plugins/clipboard'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const isPrerender = window.injectProperty && window.injectProperty.prerender
if (!isPrerender) {
  Vue.use(Toast)
}

Vue.use(Clipboard)
Vue.use(Loading, {
  loader: 'dots',
  color: '#FFD800',
  opacity: 0
}
)
router.afterEach((to, from) => {
  document.title = to.meta.title || '';
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js